/* eslint-disable @angular-eslint/component-selector */

import { Component, Input, OnInit, inject } from '@angular/core';
import { Audit } from 'app/core/models/audit.model';
import { obj2Html } from '../../../core/lib/js-utils';
import { ProviderOfficeService } from 'app/core/services/provider-office.service';
import { ProviderOffice } from 'app/core/models/provider-office.model';
import { DatePipe } from '@angular/common';
import { CopyToClipboardComponent } from '../../../shared/components/copy-to-clipboard/copy-to-clipboard.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { OfficeFaxComponent } from '../../../shared/components/office-fax/office-fax.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: '[app-audit-provider-office-create-row]',
    templateUrl: './audit-provider-office-create-row.component.html',
    styleUrls: ['./audit-provider-office-create-row.component.scss'],
    imports: [CopyToClipboardComponent,
              FaIconComponent,
              OfficeFaxComponent,
              MatProgressSpinner,
              DatePipe,
              BlankValueDashPipe]
})
export class AuditProviderOfficeCreateRowComponent implements OnInit {
  private providerOfficeService = inject(ProviderOfficeService);

  @Input() audit: Audit;
  @Input() displayNpi = false;
  @Input() displayFax = false;

  providerOffice: ProviderOffice;
  loadingProviderOffice = true;
  newValueHtml;

  ngOnInit() {
    const {
      officeId, // eslint-disable-line unused-imports/no-unused-vars
      providerId, // eslint-disable-line unused-imports/no-unused-vars
      associationNote, // eslint-disable-line unused-imports/no-unused-vars
      ...changes
    } = this.audit.auditedChanges;

    this.newValueHtml = obj2Html(changes);
    this.loadOfficeProvider();
  }

  private loadOfficeProvider() {
    this.providerOfficeService.get(this.audit.auditableId).subscribe(providerOffice => {
      this.providerOffice = providerOffice;
      this.loadingProviderOffice = false;
    });
  }
}
